// Original source is by JapMul
// codesandbox.io/s/react-fadein-out-transition-component-eww6j
// modified to include height transition

import React, { Component } from "react";

const UNMOUNTED = "unmounted";
const EXITED = "exited";
const ENTERING = "entering";
const ENTERED = "entered";
const EXITING = "exiting";

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

class FadeInOut extends Component {
  constructor(props) {
    super(props);

    this.state = { status: UNMOUNTED, maxHeight: 0, overflow: "hidden" };
  }

  componentDidMount() {
    const { show } = this.props;
    if (show) {
      this.performEnter();
    }
  }

  componentDidUpdate(prevProps) {
    let nextStatus = null;
    if (prevProps !== this.props) {
      const { status } = this.state;
      if (this.props.show) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(nextStatus);
  }

  updateStatus(nextStatus) {
    if (nextStatus !== null) {
      if (nextStatus === ENTERING) {
        this.performEnter();
      } else {
        this.performExit();
      }
    } else if (this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  }

  performEnter() {
    this.setState({ status: ENTERING, maxHeight: 0 }, () => {
      setTimeout(() => {
        this.setState(
          {
            status: ENTERED,
            maxHeight: this.props.maxHeight,
          },
          () => {
            setTimeout(() => {
              this.setState(
                {
                  overflow: "auto",
                },
                () => {}
              );
            }, this.props.duration);
          }
        );
      }, 0);
    });
  }

  performExit() {
    const { duration } = this.props;
    this.setState({ status: EXITING, maxHeight: 0, overflow: "hidden" }, () => {
      setTimeout(() => {
        this.setState({ status: EXITED, maxHeight: 0 }, () => {});
      }, duration);
    });
  }

  render() {
    const { status, overflow } = this.state;
    if (status === UNMOUNTED) {
      return null;
    }

    const { children, duration, className, style } = this.props;
    const { maxHeight } = this.state;

    return (
      <div
        ref={(node) => (this.childElement = node)}
        className={className}
        style={{
          ...style,
          transition: `opacity ${duration}ms ease-in-out, max-height ${duration}ms ease-in-out`,
          opacity: 0.1,
          overflowY: overflow,
          maxHeight: maxHeight,
          ...transitionStyles[status],
        }}
      >
        {children}
      </div>
    );
  }
}

FadeInOut.defaultProps = {
  show: false,
  duration: 300,
  maxHeight: 500,
};

export default FadeInOut;
